import React, { Component } from "react";

import classNames from 'classnames'

import './Preloader.scss'
import { publicUrl } from "../utils/url";
import { __ } from '../utils/translation';


export function Preloader({ visible = true }) {
    const [swaped, setSwaped] = React.useState(false);
    var timeout;
    React.useEffect(() => {
        timeout = setTimeout(() => {
            setSwaped(!swaped)
        }, 4000)
        return () => {
            if (timeout) clearTimeout(timeout)
        }
    })
    if (!visible) return null;

    return <div className="Preloader">
        <div className="Preloader__circle">
            <img src={publicUrl('assets/shark.png')} alt="" />
            <div className={`Preloader__label ${swaped ? 'swaped' : ''}`}>
                <div className="Preloader__label-1">
                    <div dangerouslySetInnerHTML={{ __html: __('preloader1') }} />
                </div>
                <div className="Preloader__label-2">
                    <div dangerouslySetInnerHTML={{ __html: __('preloader2') }} />
                </div>
            </div>
        </div>
    </div >


}